import React from "react";
import ReactDOM from "react-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./scss/main.scss";
import { BrowserRouter } from "react-router-dom";
import AppRoutes, { preloadRoute } from "./AppRoutes";
import ErrorBoundary from "./elements/ErrorBoundary";
import UsageObserver from "./services/UsageObserver";
import SiteTools from "./services/siteTools/SiteTools";

const mount = () => ReactDOM.render(
  <ErrorBoundary>
    <BrowserRouter>
      <UsageObserver />
      <SiteTools />
      <AppRoutes />
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById("root"),
);

// Keep the useful prerendered page visible while its calculator code arrives.
// A failed import is thrown by the page inside ErrorBoundary when mounted.
preloadRoute(window.location.pathname).then(mount, mount);
